export default __webpack_public_path__ + "static/media/arrow.0e0aa7bd.svg";